import { AttributeSelectionWidget } from 'components/FormWidget';

const uiSchema = () => ({
  attribute_id: {
    'ui:widget': AttributeSelectionWidget,
  },
});

export default uiSchema;
